class TuluaCode {
  constructor() {
    this.code = document.querySelector('.tulua-banner--code-container');

    if (!this.code) return;
    
    this.text = document.querySelector('.tulua-code-text');
    const icon = this.text.querySelector('.copy-icon');
    this.iconHTML = icon ? icon.outerHTML : '';

    // Save original text
    this.originalText = this.text.dataset.codetext || this.text.textContent.trim();
    this.init();
  }

  init() {
    this.code.addEventListener('click', () => {
      const discount = this.code.dataset.discount;

      navigator.clipboard.writeText(discount)
        .then(() => {
          // Display the discount code (or "Code copied!") + SVG
          this.text.innerHTML = 'Code copied!';

          // Optional: revert to original text after 2 seconds
          setTimeout(() => {
            this.text.innerHTML = `${this.originalText} ${this.iconHTML}`;
          }, 2000);
        })
        .catch(err => {
          console.error('Failed to copy:', err);
        })
    })
  }
}

const tuluaCode = new TuluaCode();